<template>
  <v-container>
    <List />
  </v-container>
</template>
<script>
import List from "../../components/BasePrice/List.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BasePriceHomeView",
  components: {
    List,
  },
  computed: {
    ...mapGetters({
      getItems: "basePrice/GET_ITEMS",
    }),
    items: {
      get: function () {
        return this.getItems;
      },
    },
  },
  methods: {
    ...mapActions({
      commitTitle: "common/COMMIT_TITLE",
      startRequest: "requestState/START_REQUEST",
      finishRequest: "requestState/FINISH_REQUEST",
      getItemsFromApi: "basePrice/GET_ITEMS_FROM_API",
    }),
  },
  async created() {
    this.commitTitle("Базовые прайсы");

    this.startRequest("basePriceList");

    await this.getItemsFromApi();

    this.finishRequest({
      requestName: "basePriceList",
      success: this.items != null,
    });
  },
};
</script>